import styled from "styled-components";

export const StyledRelationsGrid = styled.div`
  padding-right: ${({ theme }) => theme.space[8]};
`;
